import { render, staticRenderFns } from "./MetricsGame.vue?vue&type=template&id=0bf85cb9"
import script from "./MetricsGame.vue?vue&type=script&lang=js"
export * from "./MetricsGame.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports